import actions from './flatsActions'
import mutations from './flatsMutations'
import state from './flatsState'
import getters from './flatsGetters'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
